<template>
  <div class="condition-report-requests-list tab-table p-2">
    <condition-report-requests-table
        change-permission="change_condition_report_request"
        delete-permission="delete_condition_report_request"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ConditionReportRequestsTable from "@/modules/condition-report-requests/ConditionReportRequestsTable.vue";

  const {mapState} = createNamespacedHelpers('sales');
  const {mapActions} = createNamespacedHelpers('conditionReportRequests');

  export default {
    name: "ConditionReportRequests",
    components: {ConditionReportRequestsTable},
    computed: {
      ...mapState({
        auction: state => state.view.currentSale,
      }),
    },
    methods: {
      ...mapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        extraFilters: {auction_uuid: this.auction.uuid},
        source: 'sale'
      })
    }
  }
</script>

<style scoped>
</style>
